{
    "form_title": "New Delivery Address",
    "form_sub_title": "This will be saved in the ERP system and is visible to everyone",

    "form_label__address_line_1": "Address Line",
    "form_label__address_line_2": "Address Line 2",
    "form_label__street": "Street and House Number",
    "form_label__zip_code": "Postal Code",
    "form_label__city": "City",
    "form_label__country_code": "Country",

    "form_placeholder__address_line_1": "Sample GmbH",
    "form_placeholder__address_line_2": "c/o Sample Industrie GmbH",
    "form_placeholder__street": "Sampleweg 42",
    "form_placeholder__zip_code": "124123",
    "form_placeholder__city": "Sample City",
    "form_placeholder__country_code": "Germany"
}
